import { Component, ViewChild, effect } from '@angular/core';
import { PopupSignalService } from '../../services/popup-signal.service';
import { DxFormComponent } from 'devextreme-angular';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import { HttpService } from '../../http.service';
import { FundingTransaction } from '../home/models';

@Component({
  selector: 'app-add-money',
  templateUrl: './add-money.component.html',
  styleUrl: './add-money.component.scss'
})
export class AddMoneyComponent {

  // @ViewChild('formRef', { static: false }) formRef!: DxFormComponent;

  popupVisible = false;
  fee: number = 0;
  formData = {
    fee: this.fee,
    amount: 0,
    transferTo: '',
    type: 1,
    get depositAmount() {
      return this.amount;
    },
    get depositFee() {
      return this.amount * this.fee;
    },
    get total() {
      return (this.amount) + this.amount * this.fee;
    }
  };

  numberBoxOptions = {
    showClearButton: true,
    format: {
      type: 'currency',
      currency: 'ZAR', // Specify ZAR for South African Rand
      precision: 2
    },
    value: this.formData.amount,
    onValueChanged: (e: any) => {
      this.formData.amount = e.value;
    }
  };

  accountsDataSource = [];
  merchant: any;

  transactionTypeDataSource = [
    { text: 'Direct Debit 1', key: 1 },
    { text: 'Wire transfer', key: 2 }
  ];

  registerButtonOptions: DxButtonTypes.Properties = {
    text: 'Add Money',
    type: 'default',
    width: '120px',
    useSubmitBehavior: true,
  };

  selectedItemKeys = [1]; // Default selected item

  constructor(private popupSignalService: PopupSignalService, private httpService: HttpService) {
    effect(() => {
      this.popupVisible = this.popupSignalService.popupVisible();
    });

    httpService.getUserPricelist().subscribe(res => {
      console.log('pricelist', res);
      if (res != null && res.rate != null) {
        this.fee = res.rate;
        console.log('fee', this.fee);
      }

      this.formData = {
        fee: this.fee,
        amount: 0,
        transferTo: '',
        type: 1,
        get depositAmount() {
          return this.amount;
        },
        get depositFee() {
          return this.amount * this.fee;
        },
        get total() {
          return (this.amount) + this.amount * this.fee;
        }
      };
    });

    httpService.getUserAccounts().subscribe(res => {
      this.accountsDataSource = res;
    });

    httpService.getMerchant().subscribe(res => {
      this.merchant = res;
    });
  }

  closePopup() {
    this.popupSignalService.hidePopup();
  }

  onSelectionChanged(e: any) {
    console.log(e.addedItems[0].key);
    this.selectedItemKeys = e.component.option('selectedItemKeys');
    console.log('Selected Item:', this.selectedItemKeys);
    this.formData.type = e.addedItems[0].key;
  }

  handlePopupHiding(e: any) {
    console.log(e);
    this.popupSignalService.hidePopup();
  }

  onFormSubmit = (e: SubmitEvent) => {
    let data: FundingTransaction = new FundingTransaction(0, this.formData.amount, this.formData.type, this.formData.amount, "");
    this.httpService.createFoundInstruction(data).subscribe(res => {
      this.closePopup();
      notify({
        message: 'Request for adding the found to your account is created!',
        position: {
          my: 'center top',
          at: 'center top',
        },
      }, 'success', 3000);
      e.preventDefault();
    });
  };
}
